// extracted by mini-css-extract-plugin
export default {"button":"ObdGs5hDs2pH9bJbsTAZ","dark":"MTFoF2VeJ3Ezrp82KyZm","subtle":"Fuw8LYE0TknVnzsfsfWZ"};